// File: src/components/CreateTrainingSetDialog.jsx
import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';

export default function CreateTrainingSetDialog({ open, onClose, onCreate }) {
    const [name, setName] = useState('');
    const [domain, setDomain] = useState('');
    const [domainOptions, setDomainOptions] = useState([]);

    useEffect(() => {
        if (open) {
            async function fetchDomains() {
                try {
                    console.log("Fetching domains...");
                    

                    const response = await fetch('/api/DocumentDomains', {
                        method: 'GET',
                        credentials: 'include',
                        headers: { 'Content-Type': 'application/json' },                        
                    });


                    if (!response.ok) {
                        console.error('Error fetching domains, status:', response.status);
                        return;
                    }
                    const domains = await response.json();
                    console.log("Domains received:", domains);
                    // Map to the format needed by the dropdown.
                    const options = domains.map(d => ({
                        value: d.domainId,
                        label: d.domainName
                    }));
                    setDomainOptions(options);
                    // Set a default value if available.
                    if (options.length > 0) {
                        setDomain(options[0].value);
                    }
                } catch (error) {
                    console.error('Error fetching domains:', error);
                }
            }
            fetchDomains();
        }
    }, [open]);

    const handleCreate = () => {
        if (!name || !domain) {
            alert("Please provide both a name and a domain.");
            return;
        }
        onCreate({ name, documentDomainId: domain });
        setName('');
        setDomain('');
    };

    const handleCancel = () => {
        setName('');
        setDomain('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleCancel}>
            <DialogTitle>Create New Training Set</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Training Set Name"
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <FormControl fullWidth margin="dense">
                    <InputLabel id="domain-select-label">Domain</InputLabel>
                    <Select
                        labelId="domain-select-label"
                        value={domain}
                        label="Domain"
                        onChange={(e) => setDomain(e.target.value)}
                    >
                        {domainOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="primary">Cancel</Button>
                <Button onClick={handleCreate} variant="contained" color="primary">OK</Button>
            </DialogActions>
        </Dialog>
    );
}
